import React from 'react';
import IdNameActiveEntity from './IdNameActiveEntity';

const pmuGreen = '#00692C';

export default class CategoryEntity extends IdNameActiveEntity {

  static shape = {
    id: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    color: React.PropTypes.string.isRequired,
    rank: React.PropTypes.number.isRequired,
    national: React.PropTypes.bool.isRequired,
    active: React.PropTypes.bool.isRequired,
  };

  /**
   * The category name is a mandatory field.
   */
  static validateName = (name) => {
    if (!name || /^\s*$/.test(name)) {
      return 'Veuillez saisir un nom';
    }
    return undefined;
  };

  /**
   * Returns a new instance of CategoryEntity.
   *
   * A default color is set.
   */
  static newCategory = () => new CategoryEntity({
    id: '',
    name: '',
    color: pmuGreen,
    rank: -1,
    national: false,
  });
}



// WEBPACK FOOTER //
// ./shared/src/entity/CategoryEntity.js